<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleAdd(scope.row,scope.index)"
          >新增绑定</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >批量解除绑定</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="engineerBatchUpgrade(scope.row,scope.index)"
          >升级为工程监理</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >解除绑定</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="engineerBatchUpgrade(scope.row,scope.index)"
          >升级为工程监理</el-button>
        </template>

        <template
          slot-scope="scope"
          slot="nameForm"
        >
          <!-- <el-select v-model="currClassify" clearable placeholder="请选择系统大类">
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.rootName"
              :value="item.id"
            ></el-option>
          </el-select>-->
          <el-select
            v-model="currClassify"
            filterable
            remote
            reserve-keyword
            placeholder="请输入手机号"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { bindEngineerOption } from "@/const/salesCloud/bindEngineerOption";
import {
  findBindEngineer,
  findUserList,
  addBindEngineer,
  delBindEngineer,
  engineerBatchUpgrade, //成功绑定关系的工程师，单个升级或批量升级
} from "@/api/salesCloud/bindEngineer";

export default {
  name: "bindEngineer",
  data() {
    return {
      tableOption: bindEngineerOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    engineerBatchUpgrade(row) {
      let params = {};
      if (row) {
        console.log(row, "row = ture");
        params.ids = row.id;
        this.$confirm(`是否确认升级为工程监理?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then((res) => {
            console.log(res);
            engineerBatchUpgrade(params).then((res) => {
              if (res.code == 200) {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
              this.handleList();
            });
          })
          .catch((err) => {});
      } else {
        console.log(row, "row = false");
        let ids = this.ids;
        if (ids == "") {
          this.$message({
            showClose: true,
            message: "请选择操作数据",
            type: "error",
          });
          return;
        }
        params.ids = ids;
        this.$confirm(`是否确认升级为工程监理?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then((res) => {
            engineerBatchUpgrade(params).then((res) => {
              if (res.code == 200) {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
              this.handleList();
            });
          })
          .catch((err) => {});
      }
      console.log(params);
    },
    remoteMethod(query) {
      console.log(query.length);
      if (query.length == 11) {
        // this.loading = true;
        setTimeout(() => {
          //   this.loading = false;
          console.log("远程搜索");
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          params.manager = "NORMAL";
          findUserList(params).then((res) => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.classifySelects = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      params.clientType = "JOINS_ENGINEER";
      params.manager = "NORMAL";
      this.downloadData = params;
      findBindEngineer(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.clientType = "JOINS_ENGINEER";
      params.manager = "NORMAL";
      this.downloadData = params;
      findBindEngineer(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.clientType = "JOINS_ENGINEER";

      params.manager = "NORMAL";
      console.log(params);
      findBindEngineer(params).then((res) => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size,
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.clientType = "JOINS_ENGINEER";
      params.manager = "NORMAL";
      this.downloadData = params;
      console.log(page);
      findBindEngineer(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        console.log(data);
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        clientType: "JOINS_ENGINEER",
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      params.manager = "NORMAL";
      this.downloadData = params;
      findBindEngineer(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      row.clientType = "JOINS_ENGINEER";
      row.userId = this.currClassify;
      if (!this.currClassify) {
        this.$message({
          showClose: true,
          message: "请输入手机号",
          type: "error",
        });
        done();
        return;
      }
      addBindEngineer(row).then((res) => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map((item) => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      console.log(row);
      let ids = "";
      ids = this.ids;
      if (row) {
        ids = row.id;
        console.log(ids);
        this.$confirm(`您确定解除绑定该工程师吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delBindEngineer(ids)
              .then((res) => {
                if (res.code == "200") {
                  this.$message({
                    showClose: true,
                    message: "解除绑定成功",
                    type: "success",
                  });
                  this.handleList();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "error",
                  });
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$message({
                  showClose: true,
                  message: error,
                  type: "error",
                });
              });
          })
          .catch(() => {});
      } else {
        console.log(ids);
        if (!ids) {
          this.$message({
            showClose: true,
            message: "未选中任何数据",
            type: "error",
          });
          return;
        }
        let length = ids.split(",").length;
        this.$confirm(
          `共选中${length}位工程师，您确定批量解除绑定吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            delBindEngineer(ids)
              .then((res) => {
                if (res.code == "200") {
                  this.$message({
                    showClose: true,
                    message: "解除绑定成功",
                    type: "success",
                  });
                  this.handleList();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: "error",
                  });
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$message({
                  showClose: true,
                  message: error,
                  type: "error",
                });
              });
          })
          .catch(() => {});
      }
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
    },
  },
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
